import React from 'react';

import InquiryTypeCondition from 'components/InquiryTypeCondition';
import paths from 'constants/paths';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import DetailedInquiryInformation from 'modules/InquiryDetails/DetailedInformation/DetailedInquiryInformation';
import OnlineFactoringDetailedInquiryInformation from 'modules/InquiryDetails/DetailedInformation/OnlineFactoringDetailedInquiryInformation';
import { CbBankDetailedInquiryInformation } from 'pages/customerPortal/InquiryDetails/DetailedInformation/cbBank';
import { DzbDetailedInquiryInformation } from 'pages/customerPortal/InquiryDetails/DetailedInformation/dzb';
import { HausbankDetailedInquiryInformation } from 'pages/customerPortal/InquiryDetails/DetailedInformation/hausbank';
import { MittweidaDetailedInquiryInformation } from 'pages/customerPortal/InquiryDetails/DetailedInformation/mittweida';
import { MmvDetailedInquiryInformation } from 'pages/customerPortal/InquiryDetails/DetailedInformation/mmv';

const InquiryTypeSpecificDisplayCondition = () => {
  return (
    <InquiryTypeCondition
      portal
      cases={{
        onlinefactoring: <OnlineFactoringDetailedInquiryInformation />,
        [InquiryType.profiMittweida]: (
          <MittweidaDetailedInquiryInformation
            pathToEditInquiry={paths.operation.inquiryDetails.edit.root}
          />
        ),
        [InquiryType.mmv]: <MmvDetailedInquiryInformation />,
        [InquiryType.dzb]: <DzbDetailedInquiryInformation />,
        [InquiryType.hausbank]: <HausbankDetailedInquiryInformation />,
        [InquiryType.cbBank]: <CbBankDetailedInquiryInformation />,
        default: (
          <DetailedInquiryInformation
            pathToEditInquiry={paths.operation.inquiryDetails.edit.root}
          />
        ),
      }}
    />
  );
};

export default InquiryTypeSpecificDisplayCondition;
